import * as React from 'react';

function SvgTranslateIcon(props) {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}>
    <path
      stroke="#007BFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13"
    />
    <path
      stroke="#007BFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14.5c1.795 0 3.25-2.91 3.25-6.5S9.795 1.5 8 1.5 4.75 4.41 4.75 8 6.205 14.5 8 14.5"
    />
    <path
      stroke="#007BFF"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M1.5 8h13"
    />
  </svg>)
}
export default SvgTranslateIcon;
